import messages, { COUNT_PLACEHOLDER } from "messages";
import React from "react";
import styles from "./styles.module.scss";

type Props = { days: number };
/**
 * renders the invoice top past due tag
 */
const InvoicePastDue = ({ days }: Props) => {
  return (
    <div className={styles["invoice-past-due"]}>
      <div className={styles["invoice-past-due__label"]}>
        {messages.pastDue}
      </div>
      <div className={styles["invoice-past-due__content"]}>
        {messages.forDays.replace(COUNT_PLACEHOLDER, `${days}`)}
      </div>
    </div>
  );
};

export default InvoicePastDue;
